export default __webpack_public_path__ + "static/media/home-design-agency-img-05.5fab4c38.jpg";